// extracted by mini-css-extract-plugin
export default {"recommend":"index_recommend__hfhWI"};